import React, { FC } from 'react'

import { Button, Typography } from '@smarty-nx/ds'
import { TRACKING_CATEGORIES } from '@smarty-nx/tracking'
import { Link } from 'gatsby'

import { content } from './less-malarkey.content'
import classes from './less-malarkey.module.scss'
import EllipseCutOut from '../../components/EllipseCutOut'
import PageHead from '../../components/PageHead'
import withApp from '../../components/withApp/withApp'
import { CONFIG } from '../../config'
import logo from '../../static/images/less-malarkey/logo.gif'

const embedYouTubeURL = 'https://www.youtube-nocookie.com/embed/euoPD3DODTo'

const LessMalarkey: FC = () => {
  return (
    <div className={classes.lessMalarkey}>
      <div className={classes.topBanner}>
        <div className={classes.topBannerContent}>
          <Typography
            component="h1"
            variant="Kollektif/ExtraLarge"
            variantMd="Kollektif/Mega"
            variantLg="Kollektif/Super"
          >
            {content.headingLine1}
            <br />
            {content.headingLine2}
          </Typography>
          <Typography variant="Kollektif/Medium">
            {content.topBannerText}
          </Typography>
        </div>
        <EllipseCutOut className={classes.cutOut} />
      </div>

      <div className={classes.videoSection} id="video">
        <iframe
          src={embedYouTubeURL}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          title="video"
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </div>

      <div className={classes.bottomBanner}>
        <Typography variant="Kollektif/Small" className="margin--regular">
          {content.bottomBannerText}
        </Typography>
        <img src={logo} alt="" loading="lazy" decoding="async" />
        <Typography
          component="h2"
          variant="Kollektif/Large"
          variantLg="Kollektif/Mega"
        >
          {content.plansHeading}
        </Typography>
        <Button
          data-item-category={TRACKING_CATEGORIES.NAVIGATION}
          data-item-name="goto-homepage-plans"
          as={(props) => (
            <Link
              {...props}
              to={`${CONFIG.MARKETING_URL}#plans`}
              target="_blank"
            >
              {content.viewAllPlans}
            </Link>
          )}
        />
      </div>
    </div>
  )
}

export default withApp(LessMalarkey)

export const Head = ({ location }: { location: { pathname: string } }) => (
  <PageHead
    title={content.pageTitle}
    description={content.pageTitle}
    location={location}
  />
)
